export default "__VITE_ASSET__Bf7kxRYX__"